document.addEventListener("DOMContentLoaded", function () {
  // Find all callback containers on the page
  const callbackContainers = document.querySelectorAll(".callback-container");

  // Initialize each container
  callbackContainers.forEach(function (container) {
    const callbackButton = container.querySelector(".callback-button");
    const phoneInputContainer = container.querySelector(
      ".phone-input-container"
    );
    const phoneInput = container.querySelector(".phone-input");
    const inputWrapper = container.querySelector(".input-wrapper");
    const errorMessage = container.querySelector(".error-message");
    const thankYouMessage = container.querySelector(".thank-you-message");
    const callbackWrapper = container.querySelector(".callback-wrapper");

    // Flag to track if the input is shown
    let inputShown = false;

    // Add click event listener to the callback button
    callbackButton.addEventListener("click", function () {
      if (!inputShown) {
        // First click - show input field
        phoneInputContainer.classList.add("visible");
        inputShown = true;

        // Focus on the input field
        setTimeout(function () {
          phoneInput.focus();
        }, 300);
      } else {
        // Second click - validate and submit
        validateAndSubmit();
      }
    });

    // Add input event for real-time validation and formatting
    phoneInput.addEventListener("input", function (e) {
      // Remove any non-digit characters from input
      let value = e.target.value.replace(/\D/g, "");

      // Limit input to 9 digits
      if (value.length > 9) {
        value = value.slice(0, 9);
      }

      // Store cursor position
      const cursorPos = e.target.selectionStart;
      const previousLength = e.target.value.length;

      // Set raw digits as value (temporarily)
      e.target.value = value;

      // Validate the input
      const isValid = validateInput(false);

      // If valid, format with spaces
      if (isValid && value.length === 9) {
        const formattedValue = formatPhoneNumber(value);
        e.target.value = formattedValue;

        // Adjust cursor position for added spaces
        const newCursorPos =
          cursorPos + (e.target.value.length - previousLength);
        // Set cursor position after a small delay
        setTimeout(() => {
          e.target.selectionStart = e.target.selectionEnd = Math.min(
            newCursorPos,
            e.target.value.length
          );
        }, 0);
      }
    });

    // Format phone number with spaces (XXX XXX XXX)
    function formatPhoneNumber(number) {
      if (number.length !== 9) return number;
      return number.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
    }

    // Add blur event for validation when leaving the field
    phoneInput.addEventListener("blur", function () {
      validateInput(true);
    });

    // Add enter key listener to the phone input
    phoneInput.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        validateAndSubmit();
      }
    });

    // Input validation function
    function validateInput(showError) {
      // Get value and remove spaces for validation
      const phoneNumber = phoneInput.value.trim().replace(/\s/g, "");

      // Spanish phone number regex pattern - simplified to match numbers starting with 6 or 7 followed by 8 digits
      // since we're already providing the +34 prefix in the UI
      const spanishPhoneRegex = /^[67]\d{8}$/;

      if (spanishPhoneRegex.test(phoneNumber)) {
        // Valid phone number
        inputWrapper.classList.add("valid");
        inputWrapper.classList.remove("invalid");
        errorMessage.classList.remove("visible");
        return true;
      } else if (phoneNumber === "") {
        // Empty input
        inputWrapper.classList.remove("valid");
        inputWrapper.classList.remove("invalid");
        errorMessage.classList.remove("visible");
        return false;
      } else {
        // Invalid phone number
        inputWrapper.classList.add("invalid");
        inputWrapper.classList.remove("valid");
        if (showError) {
          errorMessage.classList.add("visible");
        }
        return false;
      }
    }

    // Validate and submit the callback request
    function validateAndSubmit() {
      const rawNumber = phoneInput.value.trim().replace(/\s/g, "");

      // Spanish phone number regex
      const spanishPhoneRegex = /^[67]\d{8}$/;

      if (spanishPhoneRegex.test(rawNumber)) {
        // Disable the input and button after submission
        phoneInput.disabled = true;
        callbackButton.disabled = true;

        // Format the number with spaces one last time
        phoneInput.value = formatPhoneNumber(rawNumber);

        // Show the thank you message
        callbackWrapper.classList.add("hidden");
        thankYouMessage.classList.add("visible");

        // Send the phone number via AJAX
        const fullPhoneNumber = "+34 " + formatPhoneNumber(rawNumber);

        fetch(rvsData.ajaxurl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            action: "save_callback_request",
            phone: fullPhoneNumber,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (!data.success) {
              console.error("Error:", data.message);
            }
          })
          .catch((error) => console.error("Error:", error));
      } else {
        validateInput(true);
      }
    }
  });
});
